import { useRecoilState } from 'recoil';
import selectedCheckboxsAtom from '../../recoils/useSelectedCheckboxsReverseSearch/selectedCheckboxsAtom';
import { BoxCellCustom } from './BoxCellCustom';

export const ReverseCheckboxCellRenderer: React.FC = (props: any) => {
  const { data } = props;
  const [listCheckbox] = useRecoilState(selectedCheckboxsAtom);

  //Handling render box cell in first row for reverse table
  if (data.typeColumn && data.typeColumn === 'first-row') {
    return <BoxCellCustom props={props} />;
  }

  //Handling render box cell in first row for reverse table
  if (data.typeColumn && data.typeColumn === 'second-row') {
    return (
      <div className="ag-cell-wrapper" role="presentation">
        <span className="ag-cell-value" role="presentation">
          <div className="ag-react-container">
            <div
              style={{
                display: 'red',
                flexDirection: 'column',
                lineHeight: 1.8
              }}
            >
              <span
                className={
                  !listCheckbox.includes(props.colDef.field)
                    ? 'hide-value'
                    : 'text-primary'
                }
              >
                {props.value}
              </span>
            </div>
          </div>
        </span>
      </div>
    );
  }

  return (
    <div className="ag-cell-wrapper" role="presentation">
      <span className="ag-cell-value" role="presentation">
        <div className="ag-react-container">
          <div
            style={{ display: 'red', flexDirection: 'column', lineHeight: 1.8 }}
          >
            <span>{props.value}</span>
          </div>
        </div>
      </span>
    </div>
  );
};
